// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "rescript/lib/es6/js_array.js";

var Raw = {};

var query = (require("@apollo/client").gql`
  fragment MediaFragment on Media   {
    __typename
    images  {
      __typename
      title
      renditions  {
        __typename
        url
        imageSize
        height
        width
      }
    }
  }
`);

function parse(value) {
  var value$1 = value.images;
  return {
          __typename: value.__typename,
          images: Js_array.map((function (value) {
                  var value$1 = value.renditions;
                  return {
                          __typename: value.__typename,
                          title: value.title,
                          renditions: Js_array.map((function (value) {
                                  var value$1 = value.imageSize;
                                  var tmp;
                                  switch (value$1) {
                                    case "ExtraExtraLarge" :
                                        tmp = "ExtraExtraLarge";
                                        break;
                                    case "ExtraLarge" :
                                        tmp = "ExtraLarge";
                                        break;
                                    case "ExtraSmall" :
                                        tmp = "ExtraSmall";
                                        break;
                                    case "Large" :
                                        tmp = "Large";
                                        break;
                                    case "Medium" :
                                        tmp = "Medium";
                                        break;
                                    case "Original" :
                                        tmp = "Original";
                                        break;
                                    case "Small" :
                                        tmp = "Small";
                                        break;
                                    default:
                                      tmp = {
                                        NAME: "FutureAddedValue",
                                        VAL: value$1
                                      };
                                  }
                                  return {
                                          __typename: value.__typename,
                                          url: value.url,
                                          imageSize: tmp,
                                          height: value.height,
                                          width: value.width
                                        };
                                }), value$1)
                        };
                }), value$1)
        };
}

function serialize(value) {
  var value$1 = value.images;
  var images = Js_array.map((function (value) {
          var value$1 = value.renditions;
          var renditions = Js_array.map((function (value) {
                  var value$1 = value.width;
                  var value$2 = value.height;
                  var value$3 = value.imageSize;
                  var imageSize = typeof value$3 === "object" ? value$3.VAL : (
                      value$3 === "ExtraSmall" ? "ExtraSmall" : (
                          value$3 === "Large" ? "Large" : (
                              value$3 === "ExtraExtraLarge" ? "ExtraExtraLarge" : (
                                  value$3 === "Small" ? "Small" : (
                                      value$3 === "Medium" ? "Medium" : (
                                          value$3 === "Original" ? "Original" : "ExtraLarge"
                                        )
                                    )
                                )
                            )
                        )
                    );
                  var value$4 = value.url;
                  var value$5 = value.__typename;
                  return {
                          __typename: value$5,
                          url: value$4,
                          imageSize: imageSize,
                          height: value$2,
                          width: value$1
                        };
                }), value$1);
          var value$2 = value.title;
          var value$3 = value.__typename;
          return {
                  __typename: value$3,
                  title: value$2,
                  renditions: renditions
                };
        }), value$1);
  var value$2 = value.__typename;
  return {
          __typename: value$2,
          images: images
        };
}

function verifyArgsAndParse(_MediaFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var MediaFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

export {
  MediaFragment ,
}
/* query Not a pure module */
